import { createFileRoute } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { McpAssistantPage } from "@/components/mcp-chat/McpAssistantPage";

export const Route = createFileRoute("/dashboard/chat")({
	component: ChatPage,
});

function ChatPage() {
	return (
		<DashboardLayout className="flex flex-col overflow-hidden pb-0">
			<McpAssistantPage />
		</DashboardLayout>
	);
}
